// search actions
export const SEARCH_INPUT_CHANGE = 'search/SEARCH_INPUT_CHANGE';
export const SUGGESTION_CLICK = 'search/SUGGESTION_CLICK';
export const SEARCH_ALGOLIA_DATA_SUCCESS = 'search/SEARCH_ALGOLIA_DATA_SUCCESS';
export const SEARCH_DATA_SUCCESS = 'search/SEARCH_DATA_SUCCESS';
export const SEARCH_DATA_FAIL = 'search/SEARCH_DATA_FAIL';
export const RESET_SEARCH_DATA = 'search/RESET_SEARCH_DATA';
